<template>
  <component :is="currentComponent" 
    v-bind:editMode="this.editMode" 
    @load="Load"
    @getInfoPatient="InfoPatient"
    @getVisibleMenu="emitToGrandparent">
  </component>
</template>

<script>
import Patient from "@/components/pages/patients/Patient";
import PatientUAE from "@/components/pages/patients/PatientUAE";
import { mapState } from "vuex";

export default {
 props: ["editMode","HaveChanges"],
  name: "PatientSwitcher",
  computed: {
    ...mapState({       
      isUAE: state => state.companies.isUAE
    }),

    currentComponent() {       
      return this.isUAE ? PatientUAE : Patient;
    }
  },

  methods:{
    InfoPatient(Info){
      this.$emit('getInfoPatient', Info);
    },
    Load(isload){
       this.$emit('load', isload); 
    },
   emitToGrandparent(options) {
    this.$emit('getVisibleMenu', options);
    }
  }
};
</script>